<template>
  <div class="quiz-result">
    <h1 class="name">{{ $t("quiz.congrats") }}</h1>
    {{ $t("quiz.finished") }}
    <div class="coords">N 50° 03.582 E 19° 56.071</div>
  </div>
</template>

<script>
export default {
  name: 'QuizResult',
}
</script>

<style scoped lang="scss">
  .quiz-result {
    font-size: 1.15rem;
    background: #fff;
    box-shadow: 0 0 3rem rgba(#000, .15);
    padding: 2rem;
  }
  .name {
    margin-bottom: 2rem;
  }
  .coords {
    text-align: center;
    font-size: 1.5rem;
    color: #fff;
    background: #3F51B5;
    padding: 1rem;
    font-weight: bold;
    margin-top: 2rem;
  }
</style>
